<template>
  <div>
    <v-card flat>
      <v-data-table
        :headers="headers"
        :items="filteredChecklists"
        :items-per-page="10"
        class="elevation-0 custom-data-table"
        :no-data-text="noDataText"
        :height="tableHeight"
        fixed-header
        :loading="tableLoading"
        density="compact"
        @click:row="handleRowClick"
      >
        <template v-slot:top>
          <div class="d-flex justify-space-between align-center pa-4">
            <span class="text-h5">Audits</span>
            <div class="d-flex align-center">
              <v-text-field
                v-model="search"
                prepend-inner-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                variant="outlined"
                density="compact"
                style="width: 350px; margin-right: 16px"
              ></v-text-field>
              <v-btn
                color="primary"
                prepend-icon="mdi-plus"
                @click="openCreateDialog"
              >
                Create Audit
              </v-btn>
            </div>
          </div>
        </template>

        <template v-slot:[`item.checklist_type`]="{ item }">
          <v-chip size="small" color="primary" variant="flat">
            {{ formatChecklistType(item.checklist_type) }}
          </v-chip>
        </template>

        <template v-slot:[`item.actions`]="{ item }">
          <v-btn
            icon
            size="small"
            variant="text"
            color="primary"
            @click.stop="editChecklist(item)"
          >
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
          <v-btn
            icon
            size="small"
            variant="text"
            color="error"
            @click.stop="deleteChecklist(item)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <!-- Create Checklist Dialog -->
    <CreateChecklistDialog
      v-model="showCreateDialog"
      @created="handleChecklistCreated"
    />

    <!-- Edit Checklist Dialog -->
    <EditChecklistDialog
      v-model="showEditDialog"
      :checklist="selectedChecklist"
      @updated="handleChecklistUpdated"
    />

    <!-- Delete Checklist Dialog -->
    <DeleteChecklistDialog
      v-model="showDeleteDialog"
      :checklist="selectedChecklist"
      @deleted="handleChecklistDeleted"
    />
  </div>
</template>

<script>
import CreateChecklistDialog from "@/components/CheckList/Dailogs/CreateChecklistDialog.vue";
import EditChecklistDialog from "@/components/CheckList/Dailogs/EditChecklistDialog.vue";
import DeleteChecklistDialog from "@/components/CheckList/Dailogs/DeleteChecklistDialog.vue";
import GetChecklists from "@/mixins/CheckList/GetChecklists";

export default {
  name: "ChecklistPage",
  mixins: [GetChecklists],
  components: {
    CreateChecklistDialog,
    EditChecklistDialog,
    DeleteChecklistDialog,
  },
  data() {
    return {
      showCreateDialog: false,
      showEditDialog: false,
      showDeleteDialog: false,
      tableLoading: false,
      selectedChecklist: null,
      checklists: [],
      search: "",
      windowHeight: window.innerHeight,
      headers: [
        { title: "Audit Name", key: "checklist_name", sortable: true },
        { title: "Type", key: "checklist_type", sortable: true },
        // { title: "Source", key: "checklist_source", sortable: true },
        { title: "Actions", key: "actions", sortable: false, align: "center" },
      ],
    };
  },
  computed: {
    noDataText() {
      return "No checklists found. Click 'Create Checklist' to add one.";
    },
    tableHeight() {
      return this.windowHeight - 230;
    },
    filteredChecklists() {
      if (!this.search) {
        return this.checklists;
      }

      const searchTerm = this.search.toLowerCase().trim();
      return this.checklists.filter((checklist) => {
        return (
          (checklist.checklist_name &&
            checklist.checklist_name.toLowerCase().includes(searchTerm)) ||
          (checklist.checklist_type &&
            checklist.checklist_type.toLowerCase().includes(searchTerm))
        );
      });
    },
  },
  async mounted() {
    this.updateWindowHeight();
    window.addEventListener("resize", this.updateWindowHeight);
    this.loadChecklists();
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateWindowHeight);
  },
  methods: {
    handleRowClick(event, { item }) {
      this.editChecklist(item);
    },
    formatChecklistType(checklistType) {
      if (checklistType == "MED_PASS_AUDIT") {
        return "Med Pass Audit";
      } else if (checklistType == "STORAGE_AUDIT") {
        return "Storage Audit";
      } else {
        return checklistType;
      }
    },
    updateWindowHeight() {
      this.windowHeight = window.innerHeight;
    },
    async loadChecklists() {
      this.tableLoading = true;
      try {
        await this.fetchChecklists({ checklist_source: "BMS" });
        this.checklists = this.checklistsList;
      } catch (error) {
        console.error("Error loading checklists:", error);
        this.checklists = [];
      } finally {
        this.tableLoading = false;
      }
    },
    openCreateDialog() {
      this.showCreateDialog = true;
    },
    async handleChecklistCreated() {
      await this.loadChecklists();
    },
    editChecklist(checklist) {
      this.selectedChecklist = { ...checklist };
      this.showEditDialog = true;
    },
    async handleChecklistUpdated() {
      await this.loadChecklists();
      this.selectedChecklist = null;
    },
    deleteChecklist(checklist) {
      this.selectedChecklist = { ...checklist };
      this.showDeleteDialog = true;
    },
    async handleChecklistDeleted() {
      await this.loadChecklists();
      this.selectedChecklist = null;
    },
  },
};
</script>

<style>
</style>